import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TutorialPanelComponent } from './tutorial-panel.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [TutorialPanelComponent],
  exports: [TutorialPanelComponent]
})
export class TutorialPanelModule { }
